import appleMusic from "url:asset/platform/apple-music.png";
import spotify from "url:asset/platform/spotify.png";
import youtubeMusic from "url:asset/platform/youtube-music.jpg";
import tidal from "url:asset/platform/tidal.jpg";
import placeholder from "url:asset/song-placeholder.svg";

// The same icon assets the app ships, copied from
// LibraryFeature/Resources/Media.xcassets (the "<Platform> Icon" imagesets
// StandardRowView loads via imageBundle: .module).

const ICONS: Record<string, string> = {
  "Apple Music": appleMusic,
  "Spotify": spotify,
  "YouTube Music": youtubeMusic,
  "Tidal": tidal,
};

/**
 * The order platforms are presented in, so every song lists them consistently.
 * Mirrors StreamingPlatform.presentationOrder in the app; anything unrecognised
 * sorts to the end.
 */
const PRESENTATION_ORDER = ["Apple Music", "Spotify", "YouTube Music", "Tidal"];

export function platformDisplayOrder(platform: string): number {
  const index = PRESENTATION_ORDER.indexOf(platform);
  return index === -1 ? PRESENTATION_ORDER.length : index;
}

export function PlatformIcon(props: { platform: string }) {
  return <img
    src={ICONS[props.platform] ?? placeholder}
    alt=""
    className="size-full object-cover"
  />
}
